import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Fingerprint03 = function Fingerprint03(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M8.1 21.221c-1.3898-1.9835-2.2074-4.3967-2.2074-7.0023 0-3.3744 2.7339-6.1093 6.1063-6.1093s6.1062 2.7349 6.1062 6.1093"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M8.1 21.221c-1.3898-1.9835-2.2074-4.3967-2.2074-7.0023 0-3.3744 2.7339-6.1093 6.1063-6.1093s6.1062 2.7349 6.1062 6.1093"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M18.4359 20.3118c-.11.0061-.2179.0163-.3289.0163-3.3723 0-6.1063-2.735-6.1063-6.1093"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M18.4361 20.3118c-.1099.0061-.2179.0163-.3288.0163-3.3724 0-6.1063-2.735-6.1063-6.1093"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M13.2694 21.9999c-2.5944-1.6179-4.3223-4.4975-4.3223-7.7812 0-1.6872 1.3674-3.0547 3.0536-3.0547s3.0536 1.3675 3.0536 3.0547 1.3675 3.0546 3.0537 3.0546 3.0536-1.3674 3.0536-3.0546c0-5.0616-4.1014-9.164-9.1599-9.164s-9.1599 4.1024-9.1599 9.164c0 1.1282.1263 2.2268.3584 3.2858"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M13.2694 21.9999c-2.5944-1.6179-4.3223-4.4975-4.3223-7.7812 0-1.6872 1.3674-3.0547 3.0536-3.0547s3.0536 1.3675 3.0536 3.0547 1.3675 3.0546 3.0537 3.0546 3.0536-1.3674 3.0536-3.0546c0-5.0616-4.1014-9.164-9.1599-9.164s-9.1599 4.1024-9.1599 9.164c0 1.1282.1263 2.2268.3584 3.2858"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M20.5257 5.8631C18.4435 3.4978 15.399 2 12.0002 2S5.5569 3.4978 3.4746 5.8631"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M20.5257 5.8631C18.4435 3.4978 15.399 2 12.0002 2S5.5569 3.4978 3.4746 5.8631"
    })]
  }));
};
export default Fingerprint03;